var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6,
    width: 24,
    height: 36,
    rx: 3,
    stroke: "#7663EB",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 9,
    height: 1,
    rx: 0.5,
    transform: "matrix(1 0 0 -1 19.5 9)",
    stroke: "#7663EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 9,
    height: 1,
    rx: 0.5,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 11.5 22)",
    stroke: "#7663EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 37.5 16)",
    stroke: "#7663EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 3,
    height: 1,
    rx: 0.5,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 37.5 22)",
    stroke: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.e95948632a8313fa02f5e8afa3ea4615.svg";
export { ForwardRef as ReactComponent };